import React from 'react';
import { FiX } from 'react-icons/fi';
import Button from '../common/Button/Button';
import LoadingText from '../common/LoadingText/LoadingText';
import { formatQuarterHourValue, roundToNearestQuarterHourValue } from '../../utils/lessonHours';
import { useI18n } from '../../i18n/language';
import './LessonHoursDialog.css';

function LessonHoursDialog({
  open,
  title = '',
  value,
  onValueChange,
  error = '',
  submitting = false,
  onClose,
  onSubmit,
}) {
  const { t } = useI18n();
  if (!open) return null;

  const handleClose = () => {
    if (submitting) return;
    onClose?.();
  };

  const handleValueBlur = () => {
    const roundedValue = roundToNearestQuarterHourValue(value);
    if (roundedValue == null) return;
    onValueChange?.(formatQuarterHourValue(roundedValue, ''));
  };

  return (
    <div
      className="lesson-hours-dialog-overlay"
      role="presentation"
      onClick={handleClose}
    >
      <div
        className="lesson-hours-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={t('lessonHours.dialogAria', '填写课时')}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="lesson-hours-dialog-head">
          <div>
            <h2 className="lesson-hours-dialog-title">{title || t('courses.submitLessonHoursTitle', '提交本节课实际课时')}</h2>
          </div>
          <button
            type="button"
            className="lesson-hours-dialog-close"
            aria-label={t('lessonHours.close', '关闭')}
            onClick={handleClose}
            disabled={submitting}
          >
            <FiX size={18} />
          </button>
        </div>

        <div className="lesson-hours-dialog-body">
          <div className="lesson-hours-dialog-row">
            <label className="lesson-hours-dialog-label" htmlFor="lesson-hours-dialog-input">
              {t('lessonHours.hoursLabel', '课时')}
            </label>
            <div className="lesson-hours-dialog-field-wrap">
              <div className="lesson-hours-dialog-field">
                <input
                  id="lesson-hours-dialog-input"
                  className="lesson-hours-dialog-input"
                  type="number"
                  min="0.25"
                  max="12"
                  step="0.25"
                  inputMode="decimal"
                  value={value}
                  onChange={(event) => onValueChange?.(event.target.value)}
                  onBlur={handleValueBlur}
                  disabled={submitting}
                />
                <span className="lesson-hours-dialog-unit">{t('lessonHours.hoursUnit', '小时')}</span>
              </div>
              <div className="lesson-hours-dialog-hint">
                {t('lessonHours.hint', '按 0.25 小时为刻度计算课时；若输入的不是 0.25 的倍数，输入后会自动调整为最接近的数值')}
              </div>
            </div>
          </div>
          {error ? (
            <div className="lesson-hours-dialog-error" role="alert">
              {error}
            </div>
          ) : null}
        </div>

        <div className="lesson-hours-dialog-actions">
          <Button
            className="lesson-hours-dialog-btn lesson-hours-dialog-btn--ghost"
            onClick={handleClose}
            disabled={submitting}
          >
            {t('common.cancel', '取消')}
          </Button>
          <Button
            className="lesson-hours-dialog-btn lesson-hours-dialog-btn--submit"
            onClick={onSubmit}
            disabled={submitting}
          >
            {submitting ? <LoadingText text={t('lessonHours.submitting', '提交中...')} /> : t('lessonHours.submit', '提交')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LessonHoursDialog;
